// ========================================
// EVENT PLANNING SECTION - HOME PAGE
// ========================================

import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/customer/home/EventPlanning.css';

const EventPlanning = () => {
  const navigate = useNavigate();

  // ── NEW: loading state for Learn More button (same pattern as CustomerDashboard) ──
  const [navLoading, setNavLoading] = useState(false);

  const handleLearnMore = () => {
    setNavLoading(true);
    setTimeout(() => {
      navigate('/packages');
      setNavLoading(false);
    }, 600);
  };

  // Services data
  const services = [
    {
      id: 1,
      title: 'Entertainment',
      icon: (
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M40 30 L45 50 L35 50 Z" fill="#e89895" opacity="0.6"/>
          <circle cx="42" cy="45" r="8" fill="#e89895" opacity="0.4"/>
          <rect x="35" y="55" width="15" height="30" rx="3" fill="#9fd4d1" opacity="0.5"/>
          <path d="M30 70 L35 55 M50 55 L55 70" stroke="#e89895" strokeWidth="2" opacity="0.6"/>
          <circle cx="35" cy="35" r="3" fill="#b8b6f7" opacity="0.5"/>
          <circle cx="48" cy="32" r="2" fill="#e89895" opacity="0.4"/>
        </svg>
      )
    },
    {
      id: 2,
      title: 'Dining',
      icon: (
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="30" y="35" width="40" height="30" rx="5" fill="#9fd4d1" opacity="0.5"/>
          <path d="M35 35 L35 25 M45 35 L45 25 M55 35 L55 25 M65 35 L65 25" stroke="#e89895" strokeWidth="2" opacity="0.6"/>
          <circle cx="50" cy="50" r="6" fill="#e89895" opacity="0.6"/>
          <path d="M30 40 L25 40 Q20 40 20 45 L20 50 M70 40 L75 40 Q80 40 80 45 L80 50" stroke="#b8b6f7" strokeWidth="2" opacity="0.5"/>
        </svg>
      )
    },
    {
      id: 3,
      title: 'Decor',
      icon: (
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M50 20 L60 40 L70 40 L60 50 L65 70 L50 60 L35 70 L40 50 L30 40 L40 40 Z" fill="#e89895" opacity="0.5"/>
          <rect x="40" y="50" width="20" height="30" rx="3" fill="#9fd4d1" opacity="0.4"/>
          <circle cx="50" cy="55" r="5" fill="#e89895" opacity="0.6"/>
          <circle cx="30" cy="30" r="3" fill="#b8b6f7" opacity="0.5"/>
          <circle cx="70" cy="35" r="2" fill="#9fd4d1" opacity="0.5"/>
        </svg>
      )
    },
    {
      id: 4,
      title: 'Swag & Gifting',
      icon: (
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="35" y="40" width="30" height="35" rx="3" fill="#9fd4d1" opacity="0.5"/>
          <path d="M50 25 Q40 35 40 40 M50 25 Q60 35 60 40" stroke="#e89895" strokeWidth="2.5" fill="none" opacity="0.6"/>
          <circle cx="50" cy="25" r="4" fill="#e89895" opacity="0.6"/>
          <rect x="48" y="40" width="4" height="15" fill="#b8b6f7" opacity="0.5"/>
          <path d="M35 50 L40 55 M65 50 L60 55" stroke="#e89895" strokeWidth="1.5" opacity="0.5"/>
        </svg>
      )
    }
  ];

  return (
    <section className="event-planning-section">
      {/* Decorative Background Elements */}
      <div className="planning-decoration decoration-1"></div>
      <div className="planning-decoration decoration-2"></div>
      <div className="planning-decoration decoration-3"></div>

      <Container>
        <div className="planning-content-wrapper">
          <div className="planning-row">
            {/* Left Side - Services Grid */}
            <div className="services-grid-col">
              <div className="services-grid">
                {services.map((service) => (
                  <div key={service.id} className="service-card">
                    <div className="service-icon">
                      {service.icon}
                    </div>
                    <h3 className="service-title">{service.title}</h3>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Side - Text Content */}
            <div className="planning-text-col">
              <div className="planning-text-content">
                {/* Top Decorative Icon */}
                <div className="planning-top-icon">
                  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M50 20 L55 35 L70 35 L58 45 L63 60 L50 50 L37 60 L42 45 L30 35 L45 35 Z" 
                          fill="#9fd4d1" opacity="0.6"/>
                    <circle cx="30" cy="30" r="3" fill="#e89895" opacity="0.5"/>
                    <circle cx="70" cy="30" r="3" fill="#e89895" opacity="0.5"/>
                    <circle cx="50" cy="70" r="2" fill="#b8b6f7" opacity="0.5"/>
                  </svg>
                </div>

                {/* Main Heading */}
                <h2 className="planning-heading">
                  Let's Plan Your Next<br />
                  Event Together
                </h2>

                {/* Description */}
                <p className="planning-description">
                  "Your dream wedding, perfectly planned. From décor to dining — we handle every detail."
                </p>

                {/* Learn More Button */}
                <button
                  type="button"
                  className="learn-more-btn"
                  onClick={handleLearnMore}
                  disabled={navLoading}
                >
                  {navLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Loading...
                    </>
                  ) : (
                    'Learn More'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default EventPlanning;